import { FeedbackConfigEnum } from "../../models/FeedbackConfigEnum";
import { FeedbackTypesEnum } from "../../models/FeedbackTypesEnum";
import { RetryConditionsEnum } from "../../models/RetryConditionsEnum";

export const questionsTypes = {
    options: {
        multiChoise: {
            regular: {
                autoSend: false,
                enableRetries: true,
                retryConditions: RetryConditionsEnum.OverAttempts,
                feedbackStatus: {
                    feedbackBeforeScore: null,
                    feedbackAfterScore: FeedbackConfigEnum.CheckedCorrect
                }
            },
            survey: {
                autoSend: false,
                enableRetries: false,
                retryConditions: null,
                feedbackStatus: {
                    feedbackBeforeScore: null,
                    feedbackAfterScore: FeedbackConfigEnum.Accepted
                }
            }
        },
        oneChoise: {
            regular: {
                autoSend: true,
                enableRetries: true,
                retryConditions: RetryConditionsEnum.OverAttempts,
                feedbackStatus: {
                    feedbackBeforeScore: null,
                    feedbackAfterScore: FeedbackConfigEnum.CheckedCorrect
                }
            },
            survey: {
                autoSend: true,
                enableRetries: false,
                retryConditions: null,
                feedbackStatus: {
                    feedbackBeforeScore: null,
                    feedbackAfterScore: FeedbackConfigEnum.Accepted
                }
            }
        }
    },
    text: {
        openText: {
            regular: {
                autoSend: false,
                enableRetries: true,
                retryConditions: RetryConditionsEnum.UntilCheck,
                feedbackStatus: {
                    feedbackBeforeScore: FeedbackConfigEnum.Accepted,
                    feedbackAfterScore: FeedbackConfigEnum.CheckedCorrect
                }
            }
        },
        closedText: {
            regular: {
                autoSend: false,
                enableRetries: true,
                retryConditions: RetryConditionsEnum.OverAttempts,
                feedbackStatus: {
                    feedbackBeforeScore: null,
                    feedbackAfterScore: FeedbackConfigEnum.CheckedCorrect
                }
            }
        }
    }
}